var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hovered-actions" },
    _vm._l(_vm.actions, function(action, actionIndex) {
      return _c(
        "CompassTooltip",
        {
          key: actionIndex,
          attrs: { content: action.textTooltip, arrow: false }
        },
        [
          _c("CompassIconButton", {
            attrs: { icon: action.icon, size: "small" },
            on: {
              click: function($event) {
                return _vm.$emit(action.id + "-clicked")
              }
            }
          })
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }